import { render } from "./genericBtnComponent.vue?vue&type=template&id=676725a2&scoped=true"
import script from "./genericBtnComponent.vue?vue&type=script&lang=js"
export * from "./genericBtnComponent.vue?vue&type=script&lang=js"

import "./genericBtnComponent.vue?vue&type=style&index=0&id=676725a2&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-676725a2"]])

export default __exports__